import { useMutation } from '@apollo/client';
import { DELETE_INTEGRATION_CONFIG, INTEGRATION_CONFIGS, } from '../graphql/queries/integrationConfig';
import { useFetchItems } from './useFetchItems';
export const useIntegrationConfigs = ({ clientId, direction }) => {
    const { items, error, loading } = useFetchItems({
        fetchQuery: INTEGRATION_CONFIGS,
        dataProp: 'integrationConfigs',
        skip: !clientId,
        spec: { clientId, direction },
    });
    const [deleteIntegrationConfig] = useMutation(DELETE_INTEGRATION_CONFIG, {
        refetchQueries: [{ query: INTEGRATION_CONFIGS, variables: { spec: { clientId } } }],
    });
    return {
        items,
        error,
        loading,
        deleteIntegrationConfig,
    };
};
